import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import _ from 'lodash';

import MobileMenu from '@/components/GlobalMenu/Mobile/MobileMenu';
import LocaleSelector from '../LocaleSelector/LocaleSelector';
import logo from '../../assets/images/sp-logo.svg';
import Placeholder from '../Placeholder';
import SocialIcon from './SocialIcon';
import Dropdown from '../GlobalMenu/Desktop/Dropdown';
import { TABLET_P } from '../../constants';

import {
  Container,
  Wrapper,
  PagesLinkSection,
  ItemsLinkSection,
  LeftSideContent,
  Logo,
  PrimaryLinks,
  PrimaryLink,
  Extras,
  IconLinks,
  SocialIcons,
  Misc,
  SecondaryLinks,
  SecondaryLink,
} from './Footer.style';

const Footer = ({ locale, primaryLinks, screenSize, secondaryLinks, footerSocialLinks, menu }) => (
  <Container>
    <Wrapper>
      {/* PC 版向け表示 */}
      {/*   SP 版の場合、次の内容を MobileMenu に包括するため、この条件分岐には含めない */}
      {/*     1. 内部リンク、2. SHISEIDO GROUP リンク、3. 言語切替、4. SNS リンク、5. 利用規約、6. 個人情報保護方針、7. コピーライト */}
      {window.innerWidth > TABLET_P && (
        <PagesLinkSection maxWidth={window.innerWidth}>
          <LeftSideContent>
            <Link to={`/${locale}`} href={`/${locale}`}>
              <Logo src={logo} alt="logo" />
            </Link>
            <PrimaryLinks>
              {primaryLinks
                ? primaryLinks.map(link => (
                    <React.Fragment>
                      {/* 商品情報リンクは非表示にしておく */}
                      {!_.get(link, 'children') && (
                        <PrimaryLink key={link.entryId}>
                          {link.external ? (
                            <a href={link.url} target="_blank">
                              {/* SHISEIDO GROUP へのリンク */}
                              {link.label}
                            </a>
                          ) : (
                            <Link to={`/${locale}${link.url}`} href={`/${locale}${link.url}`}>
                              {/* 内部リンク (例) ABOUT US) */}
                              {link.label}
                            </Link>
                          )}
                        </PrimaryLink>
                      )}
                    </React.Fragment>
                  ))
                : [0, 1, 2, 3, 4].map(key => (
                    <PrimaryLink key={key}>
                      <Placeholder h="10px" w="100px" />
                    </PrimaryLink>
                  ))}
            </PrimaryLinks>
          </LeftSideContent>
          <Extras>
            <IconLinks>
              <LocaleSelector position={screenSize > 1 ? 'top' : 'top-right'} full />

              <SocialIcons>
                {footerSocialLinks
                  ? footerSocialLinks.map(link => <SocialIcon key={link.url} type={link.type} url={link.url} />)
                  : [1, 2, 3].map(key => <Placeholder key={key} h="30px" w="30px" />)}
              </SocialIcons>
            </IconLinks>
            <Misc>
              <SecondaryLinks>
                {secondaryLinks
                  ? secondaryLinks.map(link => (
                      <SecondaryLink key={link.entryId}>
                        {link.external ? (
                          <a href={link.url} target="_blank">
                            {/* 個人情報保護方針 */}
                            {link.label}
                          </a>
                        ) : (
                          <Link to={`/${locale}${link.url}`} href={`/${locale}${link.url}`}>
                            {/* 利用規約 */}
                            {link.label}
                          </Link>
                        )}
                      </SecondaryLink>
                    ))
                  : [1, 2].map(key => (
                      <SecondaryLink key={key}>
                        <Placeholder h="10px" w="75px" />
                      </SecondaryLink>
                    ))}
              </SecondaryLinks>
            </Misc>
          </Extras>
        </PagesLinkSection>
      )}
      {/* PC 版、または SP 版向け表示 */}
      <ItemsLinkSection>
        {window.innerWidth > TABLET_P ? (
          <Dropdown top={window.pageYOffset === 0} open locale={locale} menuItem={menu} isFooterMenu />
        ) : (
          <MobileMenu open isFooterMenu screenSize={screenSize} />
        )}
      </ItemsLinkSection>
    </Wrapper>
  </Container>
);

Footer.defaultProps = {
  menu: {},
  footerSocialLinks: undefined,
  screenSize: null,
  primaryLinks: undefined,
  secondaryLinks: undefined,
};

Footer.propTypes = {
  menu: PropTypes.shape({}),
  footerSocialLinks: PropTypes.arrayOf(PropTypes.shape()),
  locale: PropTypes.string.isRequired,
  screenSize: PropTypes.number,
  primaryLinks: PropTypes.arrayOf(PropTypes.shape()),
  secondaryLinks: PropTypes.arrayOf(PropTypes.shape()),
};

const mapState = state => ({
  menu: _.find(state.siteOptions.menu, ({ contentType }) => contentType === 'siteOptionsLinkParent'),
  footerSocialLinks: state.siteOptions.footerSocialLinks,
  locale: state.locale,
  screenSize: state.screenSize,
  primaryLinks: state.siteOptions.footerPrimaryLinks,
  secondaryLinks: state.siteOptions.footerSecondaryLinks,
});

export default connect(mapState)(Footer);



// WEBPACK FOOTER //
// ./src/components/Footer/Footer.js